import type { SaleCloseUnit } from "@/domain/activity/rules";
import type { SaleClose } from "@/domain/activity/types";
import { czechPlural } from "@/lib/czech";

export const maxSaleCloseOffsetMinutes = 525600;

export const saleCloseCopy = {
  label: "Konec prodeje",
  hint: "Nevyplněno: prodej za vás ukončíme nejpozději koncem termínu.",
  customChoice: "Vlastní…",
  afterStartRefused:
    "Při ručním potvrzování nelze prodej ukončit po začátku termínu — potřebujete čas rezervaci potvrdit.",
  afterEndRefused: "Prodej nelze ponechat po konci termínu — skončený termín už si nikdo nekoupí.",
  outlivesDuration:
    "Prodej by skončil po konci termínu. Zkraťte dobu po začátku, nebo prodlužte délku termínu.",
  incomplete: "Doplňte, kolik času před nebo po termínu prodej končí.",
  offsetOutOfRange: "Nejvýše rok (525 600 minut)",
  sentenceLead: "Prodej ukončit",
  sentenceTail: "termínu",
  amountLabel: "Kolik",
  unitLabel: "Jednotka",
  directionLabel: "Před nebo po",
  anchorLabel: "Začátkem nebo koncem",
  directions: { before: "před", after: "po" },
  anchors: {
    before: { start: "začátkem", end: "koncem" },
    after: { start: "začátku", end: "konci" },
  },
  durationLabel: "Délka termínu (minut)",
  durationPlaceholder: "např. 90",
  durationHint: "Nevyplněno: konec termínu zadáte u každého termínu.",
  durationBounds: { min: "Délka musí být alespoň 1 minuta", max: "Nejvýše 1440 minut (24 hodin)" },
} as const;

const unitForms = {
  minutes: { one: "minuta", few: "minuty", many: "minut" },
  hours: { one: "hodina", few: "hodiny", many: "hodin" },
} as const;

export function saleCloseUnitLabel(unit: SaleCloseUnit, amount: number): string {
  return czechPlural(amount, unitForms[unit]);
}

export const saleClosePresets: readonly { label: string; close: SaleClose }[] = [
  { label: "Při začátku", close: { offsetMinutes: 0, anchor: "start" } },
  { label: "1 h před začátkem", close: { offsetMinutes: -60, anchor: "start" } },
  { label: "24 h před začátkem", close: { offsetMinutes: -1440, anchor: "start" } },
  { label: "Při konci", close: { offsetMinutes: 0, anchor: "end" } },
];
